var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['TitleText', {'blockquote-mode': _vm.blockquoteMode}]},[_vm._t("image"),_vm._v(" "),(!_vm.blockquoteMode)?[_vm._t("over-title")]:_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),(_vm.blockquoteMode)?[_vm._t("over-title")]:_vm._e(),_vm._v(" "),_vm._t("text"),_vm._v(" "),(_vm.blockquoteMode)?[_vm._t("sign")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }